<template>
    <IconSvg viewBox="0 0 48 48" v-bind="$attrs">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6529 7.84131L15 16.5H10.5C6.35786 16.5 3 19.8579 3 24C3 28.1421 6.35786 31.5 10.5 31.5H15L27.6529 40.1587C28.6484 40.84 30 40.1271 30 38.9208V9.0792C30 7.8729 28.6484 7.16005 27.6529 7.84131ZM35.5371 16.4921L42.2781 13.2043L40.963 10.5079L34.222 13.7957L35.5371 16.4921ZM34.5 22.5H42V25.5H34.5V22.5ZM42.2781 34.7957L35.5371 31.5079L34.222 34.2043L40.963 37.4921L42.2781 34.7957Z"></path>
    </IconSvg>
</template>

<script>
import IconSvg from '../../svg.vue';
export default {
    components: {
        IconSvg,
    },
};
</script>
